
 <!-- Top bar with logo and hamburger -->


<!-- Mobile menu overlay -->
<div *ngIf="isMobile && menuOpen" class="overlay" (click)="toggleMenu()">
  <div class="mobile-menu" (click)="$event.stopPropagation()">
    <div class="top-bar">
      
      <!-- Close button -->
      <button class="close-btn" (click)="toggleMenu()">X</button>
    </div>

    <!-- CTA buttons -->
    <button class="cta-outline">COMPARE OUR PROGRAMS</button>
    <button class="cta-solid">APPLY</button>

    <!-- Menu items -->
    <div class="menu-item" *ngFor="let section of menu">
      <div class="menu-header" (click)="toggleSection(section)">
        <span class="title7">{{ section.title }}</span>
        <span class="icon">{{ section.expanded ? '-' : '+' }}</span>
      </div>

      <div *ngIf="section.expanded" class="submenu">
        <hr>
        <div *ngFor="let item of section.children" class="submenu-item">
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</div>


 <header [ngClass]="{ 'transparent-header': !isScrolled, 'solid-header': isScrolled }" class="sticky-top" style="width: 100%;"   (mouseenter)="onMouseEnterHeader()" 
 (mouseleave)="onMouseLeaveHeader()"  *ngIf="!isMobile">
  <!-- Your header content here -->
<nav class="navbar

navbar-expand-lg navbar-light bg-white">
  <div class="container d-flex align-items-center">
    
    <!-- Left: Logo -->
  <!-- <div class="logo-containers" style="margin-top: 2%;">
  <a class="navbar-brand" href="#">
    <img [src]="logoSrc" alt="Logo" width="150" style="padding-left: 13%;" id="logo">
  </a>
</div>
 -->
 <div class="logo-containers" style="margin-top: 2%;">
  <a class="navbar-brand" href="#">
    <img [src]="logoSrc" alt="Logo" class="logo" width="150" style="padding-left: 0%;" id="logo">
  </a>
</div>


    <!-- Right: Two Divisions -->
    <div class="right-container d-flex flex-column align-items-end" >
         <!-- Bottom Div: Right-aligned Buttons -->
         <div class="button-container d-flex justify-content-end"  style="margin-right: 1%;">
          <button class="btn btn-outline-dark me-3 btn-color" >EXPLORE OUR PROGRAMS</button> &nbsp; &nbsp;
          <a href="https://apply.onesb.edu.in/" class="btn btn-outline-dark me-3 btn-color" >APPLY</a>
         <!--  <a href="https://apply.onesb.edu.in/" class="btn btn-outline-dark me-3 btn-color" 
   style="color: black; font-size: 11px; background-color: #ffffff;">
  APPLY
</a> -->


        </div>
        
      <!-- Top Div: Navigation Menu (Right-aligned) -->
      <div class="nav-container">
        
      

        <ul class="navbar-nav d-flex justify-content-end" style="margin-top: 1%;width: 100%;">
          
          <!-- ABOUT US Mega Menu -->
          <li class="nav-item dropdown mega-menu" ngbDropdown #aboutUsDropdown="ngbDropdown"
          (mouseenter)="openDropdown(aboutUsDropdown)" >
            <a class="nav-link dropdown-toggle" ngbDropdownToggle href="/about-us">ABOUT US</a>
            <div class="dropdown-menu mega-dropdown-menu" ngbDropdownMenu  (mouseenter)="aboutUsDropdown.open()"  (mouseleave)="aboutUsDropdown.close()">
              <div class="container">
                <div class="row">
                  <div class="col-md-4 col-sm-6 mb-3" style="text-align: left;">
                    <a class="dropdown-item" href="/about-us" style="font-size: 14px;font-weight: 650;"><strong>ABOUT US</strong> </a>
                    <!-- <a class="dropdown-item" href="#" style="font-size: 13px;margin-top: 8px;">Sustainability</a>
                    <a class="dropdown-item" href="#" style="font-size: 13px;">Diversity</a>
                    <a class="dropdown-item" href="#" style="font-size: 13px;">Entrepreneurship</a>
                    <a class="dropdown-item" href="#" style="font-size: 13px;">Humanities</a>
                    <a class="dropdown-item" href="#" style="font-size: 13px;">Innovation</a> -->
                  </div>
              
                  <div class="col-md-4 col-sm-6 mb-3" style="text-align: left;">
                    <a class="dropdown-item fw-bold" href="/mentors" style="font-size: 14px;font-weight: 650;"><strong>MENTORS</strong> </a>
                   <!--  <a class="dropdown-item" href="#" style="font-size: 13px;margin-top: 8px;">The Sci Tech Model</a>
                    <a class="dropdown-item" href="#" style="font-size: 13px;">Academic Partners Sci-Tech</a>
                    <a class="dropdown-item" href="#" style="font-size: 13px;">Why IE School of Science & Technology</a>
                    <a class="dropdown-item" href="#" style="font-size: 13px;">Learning Methodology</a>
                    <a class="dropdown-item" href="#" style="font-size: 13px;">Amazon Web Services Academy</a>
                    <a class="dropdown-item" href="#" style="font-size: 13px;">Microsoft Learn</a>
                    <a class="dropdown-item" href="#" style="font-size: 13px;">Members of CIVICA</a> -->
                  </div>
              
                  <div class="col-md-4 col-sm-6 mb-3" style="text-align: left;">
                    <a class="dropdown-item fw-bold" href="/college-committee" style="font-size: 14px;font-weight: 650;"><strong>COLLEGE COMMITTEE</strong></a>
                  </div>
              
                  <div class="col-md-4 col-sm-6 mb-3" style="text-align: left;">
                    <a class="dropdown-item fw-bold" href="/vision-mission" style="font-size: 14px;font-weight: 650;"><strong> VISSION MISSION</strong></a>
                   <!--  <a class="dropdown-item" href="#" style="font-size: 13px;margin-top: 8px;">Our Newsletter</a>
                    <a class="dropdown-item" href="#" style="font-size: 13px;">Open House</a> -->
                  </div>


                  <div class="col-md-4 col-sm-6 mb-3" style="text-align: left;">
                    <a class="dropdown-item fw-bold" href="/corporates" style="font-size: 14px;font-weight: 650;"><strong> CORPORATES</strong></a>
                  </div>
                </div>
              </div>
              
              
            </div>
          </li>

          <!-- PROGRAMS Mega Menu -->
          <li class="nav-item dropdown mega-menu" ngbDropdown #programsDropdown="ngbDropdown"
          (mouseenter)="openDropdown(programsDropdown)">
            <a class="nav-link dropdown-toggle" ngbDropdownToggle href="/program">PROGRAMS</a>
            <div class="dropdown-menu mega-dropdown-menu" ngbDropdownMenu     (mouseenter)="programsDropdown.open()" 
            (mouseleave)="programsDropdown.close()">
            <div class="container">
              <div class="row">
                <!-- Undergraduate -->
                <div class="col-md-4">              
                  <a class="dropdown-item" href="/courses/ug/bba-prime/overview" style="font-size: 14px;font-weight: 650;"><strong>UNDERGRADUATE</strong></a>
                  <a class="dropdown-item" href="/courses/ug/bba-prime/overview" style="font-size: 14px;margin-top: 8px;font-weight: 650;"><strong>BBA PRIME</strong></a>
                  <a class="dropdown-item" href="/courses/ug/bba-prime/overview" style="font-size: 13px;">BBA in Business Analytics</a>
                  <a class="dropdown-item" href="/courses/ug/bba-prime/overview" style="font-size: 13px;">BBA in Digital Marketing</a>
                  <a class="dropdown-item" href="/courses/ug/bba-prime/overview" style="font-size: 13px;">BBA in Logistics & Supplychain</a>
                </div>
            
                <!-- Graduate -->
                <div class="col-md-4">
                  <a class="dropdown-item" href="/courses/ug/bca-prime/overview" style="font-size: 14px;font-weight: 650;"><strong>UNDERGRADUATE</strong></a>
                  <a class="dropdown-item" href="/courses/ug/bca-prime/overview" style="font-size: 14px;margin-top: 8px;font-weight: 650;"><strong>BCA PRIME</strong></a>
                   <a class="dropdown-item" href="/courses/ug/bca-prime/overview" style="font-size: 13px;">BCA Cyber Security & Ethical Hacking</a> 
                   <a class="dropdown-item" href="/courses/ug/bca-prime/overview" style="font-size: 13px;">BCA Data Analytics</a> 
                   <a class="dropdown-item" href="/courses/ug/bca-prime/overview" style="font-size: 13px;">BCA Artificial Intelligence & Machine Learning</a> 
                </div>
            
                <!-- Master's Dual Degrees -->
                <div class="col-md-4">
                  <a class="dropdown-item" href="/courses/pg/mba-prime/overview" style="font-size: 14px;font-weight: 650;"><strong>MBA</strong></a>
                  <a class="dropdown-item" href="/courses/pg/mba-prime/overview" style="font-size: 14px;">MBA Prime</a>
                  <a class="dropdown-item" href="/courses/pg/mba-catalyst/overview" style="font-size: 14px;">MBA Catalyst</a>
                  <a class="dropdown-item" href="/courses/pg/mba-pinnacle/overview" style="font-size: 14px;">MBA Pinnacle</a>

                  <!-- <a class="dropdown-item" href="#" style="font-size: 13px;">International MBA + Master in Business Analaytics 
                    and Data Science</a>
                  <a class="dropdown-item" href="#" style="font-size: 13px;">Master in Management + Master in Computer 
                    Science and Business Technology</a>
                  <a class="dropdown-item" href="#" style="font-size: 13px;">International MBA + Master in Computer Science 
                    and Business Technology</a> -->
                </div>
            
                <!-- Certificates -->
                <div class="col-md-3">
                  <a class="dropdown-item" href="/courses/ug/bba-global/overview" style="font-size: 14px;font-weight: 650;margin-top: 50px;"><STRONG>BBA GLOBAL</STRONG></a>
                  <a class="dropdown-item" href="/courses/ug/bba-global/overview" style="font-size: 13px;margin-top: 8px;">BBA in Business Analytics</a>
                  <a class="dropdown-item" href="/courses/ug/bba-global/overview" style="font-size: 13px;">BBA in Digital Marketing</a>
                  <a class="dropdown-item" href="/courses/ug/bba-global/overview" style="font-size: 13px;">BBA in Logistics & Supplychain</a>
                 <!--  <a class="dropdown-item" href="#" style="font-size: 13px;">Dual Degree in Economics + Applied Mathematics</a> -->
                </div>

                <div class="col-md-3 w-100" style="margin-left: 100px;">
                  <a class="dropdown-item" href="/courses/ug/bca-global/overview" style="font-size: 14px;margin-top: 50px;font-weight: 650;margin-left: 3px;"><strong>BCA GLOBAL</strong></a>
                   <a class="dropdown-item" href="/courses/ug/bca-global/overview" style="font-size: 13px;margin-top: 8px;">BCA Cyber Security & Ethical Hacking</a>
                   <a class="dropdown-item" href="/courses/ug/bca-global/overview" style="font-size: 13px;">BCA Data Analytics</a> 
                   <a class="dropdown-item" href="/courses/ug/bca-global/overview" style="font-size: 13px;">BCA Artificial Intelligence & Machine Learning</a> 
                </div> 

                <div class="col-md-3">
                  <a class="dropdown-item" href="/courses/doctrate/doctorate/overview" style="font-size: 14px;font-weight: 650;margin-top: 50px;margin-left: 106px;"><strong>DOCTORATE</strong></a>
                <!--   <a class="dropdown-item" href="#" style="font-size: 13px;margin-top: 8px;">University Summer Program</a>
                  <a class="dropdown-item" href="#" style="font-size: 13px;">Pre-University Summer Program</a> -->
                </div>
              </div>
            </div>
            
            </div>
          </li>


          <li class="nav-item dropdown mega-menu" ngbDropdown #aidDropdown="ngbDropdown"
          (mouseenter)="openDropdown(aidDropdown)">
            <a class="nav-link dropdown-toggle" ngbDropdownToggle href="/admission-financial">ADMISSIONS & FINANCIAL AID</a>
            <div class="dropdown-menu mega-dropdown-menu" ngbDropdownMenu     (mouseenter)="aidDropdown.open()" 
            (mouseleave)="aidDropdown.close()">
            <div class="container">
              <div class="row">
           
                <div class="col-md-4">
                  <a class="dropdown-item" href="/admission-financial" style="font-size: 14px;font-weight: 650;"><strong>ADMISSIONS</strong></a>
                 <!--  <a class="dropdown-item" href="#" style="font-size: 13px;margin-top: 8px;">Undergraduate</a>
                  <a class="dropdown-item" href="#" style="font-size: 13px;">Master's</a> -->
                </div>

                <div class="col-md-4">
                  <a class="dropdown-item" href="/admission-financial" style="font-size: 14px;font-weight: 650;"><STRONG>FINANCIAL AID</STRONG></a>
                  <!-- <a class="dropdown-item" href="#" style="font-size: 13px;margin-top: 8px;">Undergraduate</a>
                  <a class="dropdown-item" href="#" style="font-size: 13px;">Master's</a> -->
                </div>

                <div class="col-md-4">
                  <a class="dropdown-item" href="/admission-financial" style="font-size: 14px;font-weight: 650;"><strong>STUDENT SERVICES</strong></a>
               <!--    <a class="dropdown-item" href="#" style="font-size: 13px;margin-top: 8px;">Undergraduate</a>
                  <a class="dropdown-item" href="#" style="font-size: 13px;">Master's</a> -->
                </div>
              </div>
            </div>
            
            </div>
          </li>
  
          <li class="nav-item dropdown mega-menu" ngbDropdown #experienceDropdown="ngbDropdown"
          (mouseenter)="openDropdown(experienceDropdown)">
            <a class="nav-link dropdown-toggle" ngbDropdownToggle href="/campus-life">LIFE AT ONESB</a>
            <div class="dropdown-menu mega-dropdown-menu" ngbDropdownMenu     (mouseenter)="experienceDropdown.open()" 
            (mouseleave)="experienceDropdown.close()">
            <div class="container">
              <div class="row">
                <!-- campus life -->
                <div class="col-md-4">              
                  <a class="dropdown-item" href="/campus-life" style="font-size: 14px;font-weight: 650;"><strong>CAMPUS LIFE</strong></a>
                </div>
            
                <!-- talent & careers -->
                <!-- <div class="col-md-4">
                  <a class="dropdown-item" href="#" style="font-size: 14px;font-weight: 650;"><strong>TALENT & CAREERS</strong></a>
                </div> -->
            
              
            
                <!-- STUDENT & ALUMNI STORIES -->
                <div class="col-md-3">
                  <a class="dropdown-item" href="/students-alumni" style="font-size: 14px;font-weight: 650;"><STRONG> STUDENT & ALUMNI STORIES </STRONG></a>
                </div>
                  
               <!--  CHAT WITH OUR STUDENTS AND STAFF -->
                <div class="col-md-3 w-100" >
                  <a class="dropdown-item" href="/chat-students-staff" style="font-size: 14px;font-weight: 650; margin-left: 100%;"><STRONG>CHAT WITH OUR STUDENTS AND STAFF</STRONG></a>
                  <!-- <a class="dropdown-item" href="#" style="font-size: 13px;margin-top: 8px;">Undergraduate</a>
                  <a class="dropdown-item" href="#" style="font-size: 13px;">Master's</a> -->
                </div>
                
              <!--   OUR SPACES -->
                <div class="col-md-3" style="margin-left: 105px;">
                  <!-- <a class="dropdown-item" href="#" style="font-size: 14px;font-weight: 650;margin-top: 50px;"><strong> OUR SPACES</strong></a>
                  <a class="dropdown-item" href="#" style="font-size: 13px;margin-top: 8px;">Campus Tour</a> -->
                  <!-- <a class="dropdown-item" href="#" style="font-size: 13px;">Campus Segovla</a>
                  <a class="dropdown-item" href="#" style="font-size: 13px;">Campus Madrid</a> -->
                </div>
              </div>
            </div>
            
            </div>
          </li>

          <li class="nav-item dropdown mega-menu" ngbDropdown #researchDropdown="ngbDropdown"
          (mouseenter)="openDropdown(researchDropdown)">
            <a class="nav-link dropdown-toggle" ngbDropdownToggle href="/faculty">FACULTY & RESEARCH</a>
            <div class="dropdown-menu mega-dropdown-menu" ngbDropdownMenu     (mouseenter)="researchDropdown.open()" 
            (mouseleave)="researchDropdown.close()">
            <div class="container">
              <div class="row">
                <!-- FACULTY -->
                <div class="col-md-4">              
                  <a class="dropdown-item" href="/faculty" style="font-size: 14px;font-weight: 650;margin-top: 30px; margin-bottom: 40px;"><strong>FACULTY</strong></a>
                </div>
            
                <!-- RESEARCH -->
                <div class="col-md-4">
                  <a class="dropdown-item" href="/research" style="font-size: 14px;font-weight: 650;margin-top: 30px;margin-left: 200px;margin-bottom: 40px"><strong>RESEARCH</strong></a>
                </div>
              </div>
            </div>
            
            </div>
          </li>

          <li class="nav-item dropdown mega-menu" ngbDropdown #centersDropdown="ngbDropdown"
          (mouseenter)="openDropdown(centersDropdown)">
            <a class="nav-link dropdown-toggle" ngbDropdownToggle href="/placement">PLACEMENT & STARTUPS</a>
            <div class="dropdown-menu mega-dropdown-menu" ngbDropdownMenu     (mouseenter)="centersDropdown.open()" 
            (mouseleave)="centersDropdown.close()">
            <div class="container">
              <div class="row">

                <div class="col-md-4">              
                  <a class="dropdown-item" href="/placement" style="font-size: 14px;font-weight: 650;margin-top: 30px; margin-bottom: 40px;"><strong>PLACEMENTS</strong></a>
                </div>

                <div class="col-md-4">              
                  <a class="dropdown-item" href="/our-recruiters" style="font-size: 14px;font-weight: 650;margin-top: 30px; margin-bottom: 40px;"><strong>OUR RECRUITERS</strong></a>
                </div>
              
                <div class="col-md-4">              
                  <a class="dropdown-item" href="/ai-lab" style="font-size: 14px;font-weight: 650;margin-top: 30px; margin-bottom: 40px;"><strong>ARTIFICIAL INTELLIGENCE LAB</strong></a>
                </div>
            
               
                <div class="col-md-4">
                  <a class="dropdown-item" href="/mentorship" style="font-size: 14px;font-weight: 650;margin-top: 30px;"><strong>MENTORSHIP PROGRAM</strong></a>
                </div>

                <div class="col-md-4">
                  <a class="dropdown-item" href="/tech-venture" style="font-size: 14px;font-weight: 650;margin-top: 30px;"><strong>TECH VENTURE BOOTCAMP</strong></a>
                </div>

              <!--   <div class="col-md-4">
                  <a class="dropdown-item" href="#" style="font-size: 14px;font-weight: 650;margin-top: 30px;"><strong>IE SUSTAINABILITY DATATHON</strong></a>
                </div>

                <div class="col-md-4">
                  <a class="dropdown-item" href="#" style="font-size: 14px;font-weight: 650;margin-top: 30px;"><strong>RISE EUROPE ALLIANCE</strong></a>
                </div>

                <div class="col-md-4">
                  <a class="dropdown-item" href="#" style="font-size: 14px;font-weight: 650;margin-top: 30px;"><strong>BERKELEY IMMERSION WEEK</strong></a>
                </div>

                <div class="col-md-4">
                  <a class="dropdown-item" href="#" style="font-size: 14px;font-weight: 650;margin-top: 60px;margin-bottom: 40px"><strong>METAVERSE CATALYST CONFERENCE</strong></a>
                </div>

                <div class="col-md-4">
                  <a class="dropdown-item" href="#" style="font-size: 14px;font-weight: 650;margin-top: 60px;margin-bottom: 40px"><strong>MANAGEMENT XPONENTIAL TECHONOLOGY (MXT)</strong></a> 
                </div>-->
              </div>
            </div>
            
            </div>
          </li>
        </ul>
      </div>

   

    </div>
  </div>
</nav>
</header>

